<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" id="chapter-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-if="!chapter_id">章追加</h5>
                    <h5 class="modal-title" v-else>章編集</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label>章の名称</label>
                        <input type="text" ref="chapterName" class="form-control" v-model="chapter.section_name" placeholder="例）第１章" @keydown.enter="save($event)" />
                    </div>
                    <div class="text-muted small">
                        章はエピソード群の区切りとして追加できます。
                        追加した章は挿入位置を調整できます
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">閉じる</button>
                    <button type="button" class="btn btn-outline-primary" @click="save()">保存 (Enter)</button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.section {
    font-size: 1.1rem;
}
</style>

<script>
export default {
    props: {
        chapter_id: {
            default: null,
        },
        book_id: {
            required: true,
        },
    },
    data() {
        return {
            chapter: {},
        }
    },
    methods: {
        load() {
            setTimeout(() => {this.$refs.chapterName.focus();}, 500);
            if (! this.chapter_id) {
                this.chapter = {
                    book_id: this.book_id
                };
                return
            };
            axios.get("/mypage/chapter/get", {params: {id: this.chapter_id}}).then(res => {
                this.chapter = res.data;
            }).catch(err => {
                alert.err(err.response);
            });
        },
        save(ev) {
            if (ev && ev.keyCode !== 13) return;
            axios.post("/mypage/chapter/save", this.chapter).then(res => {
                alert.msg(res.data);
                this.$emit("saved", this.chapter.id ? false : true);
                $("#chapter-modal").modal("hide");
            }).catch(err => {
                alert.err(err.response);
            });
        },
    },
    computed: {
        thisChapter() {
            return _.find(this.chapters, {id: this.chapter_id});
        }
    },
    mounted() {
        $("#chapter-modal").on("show.bs.modal", (e) => {
            this.load();
        });
        $("#chapter-modal").on("hide.bs.modal", (e) => {
            this.$emit("closed");
        });
    }
}
</script>